import { useDispatch, useSelector } from 'react-redux';
import {
  getConsultantCurrentlyViewedStep,
  getConsultantTutorialSteps,
  getConsultantTutorialTotalSteps,
} from '../../../reducers/ConsultantTutorialReducer/ConsultantTutorialSelectors';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';
import * as React from 'react';
import { useState } from 'react';

import '../TutorialButtons.scss';
import { ConsultantTutorialActions } from '../../../reducers/ConsultantTutorialReducer/ConsultantTutorialReducer';
import analytics from '../../../shared/services/analytics/analytics';
import Parser from 'html-react-parser';

export function ConsultantTutorialButtons() {
  const dispatch = useDispatch();
  const [isHintShown, setIsHintShown] = useState(false);
  const [isAnswerShown, setIsAnswerShown] = useState(false);

  const currentPage = useSelector(getConsultantCurrentlyViewedStep);
  const steps = useSelector(getConsultantTutorialSteps);
  const pageCount = useSelector(getConsultantTutorialTotalSteps);
  const isNextPageAvailable = currentPage !== pageCount - 1;
  const isPreviousPageAvailable = currentPage > 0;

  const currentHint = steps?.[currentPage]?.hint;
  const currentAnswer = steps?.[currentPage]?.answer;

  function handleNext() {
    dispatch(ConsultantTutorialActions.setNextStep());
    setIsHintShown(false);
    setIsAnswerShown(false);
  }

  function handlePrevious() {
    dispatch(ConsultantTutorialActions.setPreviousStep());
    setIsHintShown(false);
    setIsAnswerShown(false);
  }

  const handleShowAnswer = () => {
    analytics.trackCustomEvent('consultant_tutorial_click_show_answer', { event_label: currentPage.toString() });
    setIsAnswerShown(true);
  };
  const handleShowHint = () => {
    analytics.trackCustomEvent('consultant_tutorial_click_show_hint', { event_label: currentPage.toString() });
    setIsHintShown(true);
  };
  const isHintSectionShown = currentPage !== pageCount - 1 && (currentHint || currentAnswer);
  return (
    <>
      {isHintSectionShown && (
        <div className="tutorial-buttons__hint-section">
          {currentHint && (
            <div className="tutorial-buttons__hint">
              {isHintShown ? (
                <div>
                  <FormattedMessageHelper tagName="strong" id="navigatorTutorial.hint" />
                  {Parser(currentHint)}
                </div>
              ) : (
                <button className="ui basic button" onClick={handleShowHint}>
                  <FormattedMessageHelper tagName="span" id="navigatorTutorial.showHint" />
                </button>
              )}
            </div>
          )}
          {currentAnswer && (
            <div className="tutorial-buttons__answer">
              {isAnswerShown ? (
                <div>
                  <FormattedMessageHelper tagName="strong" id="navigatorTutorial.answer" />
                  {Parser(currentAnswer)}
                </div>
              ) : (
                <button className="ui basic button" onClick={handleShowAnswer}>
                  <FormattedMessageHelper tagName="span" id="navigatorTutorial.showAnswer" />
                </button>
              )}
            </div>
          )}
        </div>
      )}
      <div className="tutorial-buttons">
        <button
          className="tutorial-buttons__button ui button button--secondary"
          onClick={handlePrevious}
          disabled={!isPreviousPageAvailable}
        >
          <FormattedMessageHelper tagName="span" id="navigatorTutorial.previousPage" />
        </button>

        <div>
          <button className="tutorial-buttons__button ui primary button" onClick={handleNext} disabled={!isNextPageAvailable}>
            <FormattedMessageHelper tagName="span" id="navigatorTutorial.nextPage" />
          </button>
        </div>
      </div>
    </>
  );
}
